import TeamChecks from '@/views/Check/TeamChecks'

const routes = {
  path: '/teamChecks',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/teamChecks',
      name: 'Pontos da equipe',
      component: TeamChecks,
    },
  ],
}

export default routes
